import React, { useState, useEffect } from "react";
import TreeView from "@mui/lab/TreeView";
import TreeItem from "@mui/lab/TreeItem";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const StarekTreeView = (props) => {
  const [editNodeId, setEditNodeId] = useState(null);
  const [editLabel, setEditLabel] = useState("");
  const [expanded, setExpanded] = useState([]);
  useEffect(() => {
    if (props.treeData.length === 0) {
      const defaultZone = [
        { id: `${Date.now()}`, label: "Default Zone", children: [] },
      ];
      props.setTreeData(defaultZone);
    }
  }, [props.treeData.length]);
  const handleAddBranch = (id) => {
    const newTreeData = [...props.treeData];
    const addNodeRecursively = (nodes) => {
      nodes.forEach((node) => {
        if (node.id === id) {
          if (!node.children) {
            node.children = [];
          }
          const newId = `${Date.now()}`;
          node.children.push({ id: newId, label: `New Branch ${newId}` });
          setExpanded((prevExpanded) => {
            const newExpanded = [...new Set([...prevExpanded, id])];
            return newExpanded;
          });
        } else if (node.children) {
          addNodeRecursively(node.children);
        }
      });
    };
    addNodeRecursively(newTreeData);
    props.setTreeData(newTreeData);
  };

  const handleDeleteLeaf = (nodeId) => {
    const newTreeData = [...props.treeData];
    const deleteLeafRecursively = (nodes) => {
      return nodes.filter((node) => {
        if (node.children) {
          node.children = deleteLeafRecursively(node.children);
        }
        return node.id !== nodeId;
      });
    };
    const updatedTree = deleteLeafRecursively(newTreeData);
    props.setTreeData(updatedTree);
  };
  const handleEditStart = (nodeId, currentLabel) => {
    setEditNodeId(nodeId);
    setEditLabel(currentLabel);
  };
  const handleEditEnd = (nodeId) => {
    const newTreeData = [...props.treeData];

    const updateNodeRecursively = (nodes) => {
      nodes.forEach((node) => {
        if (node.id === nodeId) {
          node.label = editLabel;
        } else if (node.children) {
          updateNodeRecursively(node.children);
        }
      });
    };
    updateNodeRecursively(newTreeData);
    props.setTreeData(newTreeData);
    setEditNodeId(null);
    setEditLabel("");
  };
  const handleEditCancel = () => {
    setEditNodeId(null);
    setEditLabel("");
  };
  const renderTree = (nodes) => (
    <TreeItem
      className="bg-color-f7f5f5 rounded py-2"
      key={nodes.id}
      nodeId={nodes.id}
      label={
        <div className="d-flex justify-content-between align-items-center">
          {editNodeId === nodes.id ? (
            <div className="d-flex align-items-center">
              <input
                className="form-control form-control-sm"
                type="text"
                value={editLabel}
                onChange={(e) => setEditLabel(e.target.value)}
                autoFocus
              />
              <i
                className="fa fa-check ms-2 cursor-pointer"
                onClick={() => handleEditEnd(nodes.id)}
              ></i>
              <i
                className="fa fa-times text-danger ms-2 cursor-pointer"
                onClick={handleEditCancel}
              ></i>
            </div>
          ) : (
            <div className="d-flex align-items-center">
              <span
                onDoubleClick={() => handleEditStart(nodes.id, nodes.label)}
              >
                {nodes.label}
              </span>
              <i
                className="fa fa-pen ms-2 cursor-pointer"
                onClick={() => handleEditStart(nodes.id, nodes.label)}
              ></i>
            </div>
          )}
          <span>
            {!nodes.children || nodes.children.length === 0 ? (
              <i
                className="fa fa-minus text-dark cursor-pointer ms-2"
                onClick={() => handleDeleteLeaf(nodes.id)}
              ></i>
            ) : null}
            <i
              className="ms-2 fa fa-plus text-dark cursor-pointer"
              onClick={() => handleAddBranch(nodes.id)}
            ></i>
          </span>
        </div>
      }
    >
      {Array.isArray(nodes.children)
        ? nodes.children.map((node) => renderTree(node))
        : null}
    </TreeItem>
  );

  return (
    <TreeView
      aria-label="multi-level tree view"
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      sx={{
        height: 240,
        flexGrow: 1,
        maxWidth: "100%",
        width: "100%",
        overflowY: "auto",
      }}
      expanded={expanded}
      onNodeToggle={(event, nodeIds) => {
        setExpanded((prevExpanded) => [
          ...new Set([...prevExpanded, ...nodeIds]),
        ]);
      }}
    >
      {props.treeData.length > 0 ? (
        props.treeData.map((node) => renderTree(node))
      ) : (
        <div>No Zones Available</div>
      )}
    </TreeView>
  );
};

export default StarekTreeView;
